import {
  Card,
  Table,
  Button,
  Modal,
  Tabs,
  Typography,
  Row,
  message,
  Tooltip,
  Select,
  theme
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import SearchBox from "../components/SearchBox";
import React, { useEffect, useRef, useState } from "react";
import { Loader } from "../components/loader";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { BsPlus } from "react-icons/bs";
import useFetch from "../_fetch";
import CreateQuery from "./createQuery";
import Query from "./Query";
import Fyassign from "../components/querySidebar/fyAsing";
import CommentView from "../components/commentView";
import PermissionModal from "../components/PermissionModal";
import { user_role, query_type } from "../consts";
import Documents from "./Documents";
import SendDocumentsModal from "../components/files/SendDocumentsModal";
import ReviewPoints from "../components/Tabs/ReviewPoints";
import { useGetAllFinancialYears, useGetAllPrimaryQueries, useGetAllQueries, useGetAllUsers } from "../utils/queryUtils";
import { setReloadQuery } from "../store/action/reload";
import UserInfo from '../components/userInfo';
import CopyQuery from "./CopyQuery";
import BulkAssignClients from "./BulkAssignClients";

import { useIsPrimaryClientView } from "../utils/useIsPrimaryClientView";
import SendEmailView from "../components/SendEmailView";
var QuillDeltaToHtmlConverter =
  require("quill-delta-to-html").QuillDeltaToHtmlConverter;

export function useQuery(search) {
  const location = useLocation();
  return React.useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
}


export default function AllQueries() {
  const { fy: selectedFy } = useSelector(st => st.selected);
  const [currentPage, setCurrentPage] = useState(1);
  const { role } = useSelector((st) => st.user);
  const { token: { colorPrimary } } = theme.useToken();
  const [, setIsPrimaryQuery] = useState(false);
  const [isQueryModalOpen, setIsQueryModalOpen] = useState(null);
  const [selectedTargetFY, setSelectedTargetFY] = useState(null);
  // const { data: fy } = useGetAllFinancialYears();

  const [selectedTab, setSelectedTab] = useState(() => {
    const tabFromParams = new URLSearchParams(window.location.search).get("tab");
    if (tabFromParams) return tabFromParams;
    return role === user_role.PRIMARY_CLIENT ? "primary_client_queries" : "queries";
  });
  const selectedPrimaryClient = useSelector((st) => st.selected.primaryClient);
  const allQueriesNormal = useGetAllQueries(selectedFy?._id, "NORMAL", currentPage, false);
  const allQueriesPrimary = useGetAllPrimaryQueries(
    selectedFy?._id, "NORMAL", currentPage, true, {}, selectedPrimaryClient?._id
  );

  const shouldUsePrimaryQueries = selectedTab === "primary_client_queries" || !!selectedPrimaryClient?._id;
  const getAllQueries = shouldUsePrimaryQueries ? allQueriesPrimary : allQueriesNormal;
  const allQueries = getAllQueries?.data?.data;
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const { client } = useSelector(st => st.selected)
  const { company } = useSelector(st => st.selected)
  const { fy } = useSelector(st => st.selected)
  const { reloadQuery } = useSelector((st) => st.reload);

  const { data: all_fys, refetch } = useGetAllFinancialYears();
  const allFIlteredFys = all_fys?.data?.filter(fy => fy?.company?._id === company?._id)
  const [isMailModalOpen, setIsMailModalOpen] = useState(false);
  const [showDocs, setShowDocs] = useState(false);
  const [modalQueryId, setModalQueryId] = useState(null);
  const [copyQueryApiFetch, setCopyQueryApiFetch] = useState(false);
  const [show, setShow] = useState([]);
  const mailRef = useRef();
  const [comments, setComments] = useState([]);
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const [, setUpdatedquery] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "queries");
  const [printLoading, setPrintLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [copyQueryModal, setCopyQueryModal] = useState(false);
  const placeholder = "Search Queries";
  const user = useSelector((st) => st.user);
  const [queryIdValue, setIsQueryIdValue] = useState("");
  const [showQuery, setShowQuery] = useState(false);
  const [showReviewQuery, setShowReviewQuery] = useState(false);
  const [reviewQueryRefreshToggle] = useState(false);
  const [seed, setSeed] = useState(1);
  const [permissionModalOpen, setPermissionModalOpen] = useState(null);
  let query = useQuery("search");
  const _fetch = useFetch();
  const [toggle, setToggle] = useState(true);
  const userData = useGetAllUsers()?.data;
  const all_users = userData?.data;
  const { Option } = Select;
  const { isReadOnly } = useIsPrimaryClientView();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [bulkAssignModal, setBulkAssignModal] = useState(false);



  useEffect(() => {
    if (copyQueryApiFetch === true) {
      allQueriesPrimary.refetch();
      allQueriesNormal.refetch();
      setCopyQueryApiFetch(false);
    }
  }, [copyQueryApiFetch]);

  useEffect(() => {
    allQueriesNormal.refetch();
    allQueriesPrimary.refetch();
  }, []);
  const handlePrintQueries = async () => {
    if (!selectedFy?._id) {
      throw new Error('Please select a financial year first');
    }

    try {
      setPrintLoading(true);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/query/pdf?fy=${selectedFy._id}`);
      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const arrayBuffer = await response.arrayBuffer();
      const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

      const fyStart = new Date(selectedFy.start).getFullYear();
      const fyEnd = new Date(selectedFy.end).getFullYear();
      const filename = `Query_Report_FY${fyStart}-${fyEnd}.pdf`;

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      message.success("Report downloaded successfully");
    } catch (error) {
      console.error("Download failed:", error);
      message.error("Something went wrong");
    } finally {
      setPrintLoading(false);
    }
  };


  const reset = () => {
    setSeed(Math.random());
  };

  const showModal = () => {
    setIsMailModalOpen(true);
  };

  const handleClick = () => {
    let body = ``;
    allQueries?.forEach((e, i) => {
      var converter = new QuillDeltaToHtmlConverter(e.descriptionV2, []);
      let htmlConverted = converter.convert();
      let html = `
      
      <p style="font-size:12px">${i + 1}.${e.title}</p>${htmlConverted}`;
      body += html;
    });
    body = `<p style="font-size:12px" >Dear Client</p>
      <p style="font-size:12px" >We are in the process of completing the <b>${moment(
      selectedFy.start
    ).format("YYYY")} - ${moment(selectedFy.end).format(
      "YY"
    )}</b>  tax return for <b>${client?.title}</b>. Please provide the information requested in the following queries at your earliest convenience.</p> ${body}`;
    displayDesc.current = body;
    showModal();
  };

  const handleTableChange = (pagination, filters, sorter) => {
    try {
      setCurrentPage(() => pagination);
    }
    catch (err) {
      console.error(err)
    }
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "s_no",
      key: "s_no",
      width: "1%",
      sorter: (a, b) => a.s_no - b.s_no,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: "20%",
      sorter: (a, b) => {
        return `${a.title.toLowerCase()}` > `${b.title.toLowerCase()}`
          ? 10
          : -10;
      },
      onFilter: (value, record) => record.title === value,
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      sorter: (a, b) => {
        return `${a.status.toLowerCase()}` > `${b.status.toLowerCase()}`
          ? 10
          : -10;
      },
      render(record) {
        return (
          <div
            style={{
              padding: "5px",
              borderRadius: "10px",
              textAlign: "center",
              backgroundColor: record === "CLOSED" ? "green" : null,
              color: record === "CLOSED" ? "white" : "",
            }}
          >
            {record}
          </div>
        );
      },
      onFilter: (value, record) => record.status === value,
    },
    ...(role === user_role.ADMIN || role === user_role.ACCOUNTANT
      ? [
        {
          title: `${role === user_role.PRIMARY_CLIENT ? "Financial Year" : "No. of Financial Years"}`,
          dataIndex: "migrate_query",
          key: "migrate_query",
          render: (text, record) => (
            <Row style={{ alignItems: "center" }}>
              <Button
                type="primary"
                disabled={isReadOnly}
                onClick={(e) => {
                  e.stopPropagation()
                  if (isReadOnly) return
                  setIsQueryModalOpen(record)
                }}
              >
                Migrate Query
              </Button>
            </Row>
          ),
        },
      ]
      : []),
    {
      title: "Created On",
      key: "createdAt",
      sorter: (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      render: (record) => moment(record.createdAt).format("DD MMM YYYY"),
    },
    {
      title: "Query Owner",
      key: "createdBy",
      sorter: (a, b) => {
        return `${a.created_by?.first_name} ${a.created_by?.last_name}`.toLowerCase() >
          `${b.created_by?.first_name} ${b.created_by?.last_name}`.toLowerCase()
          ? 10
          : -10;
      },
      render: (record) =>
        `${record.created_by?.first_name} ${record.created_by?.last_name}`,
      onFilter: (value, record) =>
        `${record.created_by.first_name} ${record.created_by.last_name}` ===
        value,
    },
    ...(role === user_role.STAFF
      ? [
        {
          title: `${selectedTab === "primary_client_queries" ? "Primary Client" : "Assign Primary Client"}`,
          key: "assign_primary_client",
          render: (record) => {
            const isPrimaryClientAndQuery = record.primary_client_query;
            if (isPrimaryClientAndQuery) {
              const assignedUsers = all_users?.filter(user =>
                record?.primary_client_assigned?.includes(user._id)
              );
              return (
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  {assignedUsers?.map(user => (
                    <UserInfo
                      key={user._id}
                      firstName={user.first_name}
                      lastName={user.last_name}
                      email={user.email}
                    />
                  ))}
                </div>
              );
            }

            return (
              <Button
                type="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsQueryIdValue(record.query_id);
                  setCopyQueryModal(true);
                }}
              >
                Assign Query
              </Button>
            );


          }
        },
      ]
      : []),
    {
      title: "",
      key: "actions",
      render: (record) => (
        <Row style={{ alignItems: "center" }}>
          <Button
            type="primary"
            onClick={() => navigate(`${record?.query_id}?tab=${selectedTab}`)}
          >
            View Query
          </Button>
        </Row>
      ),
    },
  ];

  const init = async () => {
    try {
      if (selectedFy) {
        const primaryClientParam = selectedPrimaryClient?._id
          ? `&primary_client_id=${selectedPrimaryClient._id}`
          : '';

        let commRes = await _fetch(
          `${process.env.REACT_APP_API_URL}/comment?fy_id=${selectedFy?._id}${primaryClientParam}`
        );
        commRes = await commRes.json();
        setComments(commRes.result);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {

    allQueriesNormal.refetch();
    allQueriesPrimary.refetch();
  }, []);
  useEffect(() => {
    if (reloadQuery === true) {
      getAllQueries.refetch()
      dispatch(setReloadQuery(false))
    }
  }, [reloadQuery])

  useEffect(() => {
    if (allQueries) {
      setShow(allQueries);
      setPagination((prev) => ({
        ...prev,
        current: getAllQueries?.data?.pagination?.current,
        total: getAllQueries?.data?.pagination?.total,
      }));
    }
  }, [allQueries, reloadQuery]);


  useEffect(() => {
    init();
    setSelectedRowKeys([]);
  }, [selectedFy, selectedPrimaryClient?._id, seed]);

  const handleFyUpdate = async (update) => {

    const payload = {
      ...update,
      fy: query.get("fy"),
    };
    let updatedQuery = await _fetch(`${process.env.REACT_APP_API_URL}/fy`, {
      method: "PATCH",
      body: payload,
    });
    let resJson = await updatedQuery.json();

    if (resJson.status === 200) {
      // dispatch(changeSelectedFY(resJson.response));
    }
  };

  const refresh = () => {
    reset();
  };

  async function deleteFY() {
    try {
      let res = await _fetch(`${process.env.REACT_APP_API_URL}/fy`, {
        method: "DELETE",
        body: {
          id: permissionModalOpen,
          user_id: user?._id,
        },
      });
      res = await res.json();
      if (res.status === 200) {
        message.success("Financial Year deleted successfully");
        navigate("/", { replace: true });
      } else {
        message.error(res.response);
      }
    } catch (err) {
      message.error("Something went wrong");
      console.error(err);
    } finally {
      setPermissionModalOpen(null);
    }
  }

  const [showButton, setShowButton] = useState(activeTab);
  const [initialTypeValue, setInitialTypeValue] = useState();
  const displayDesc = useRef({ content: {}, html: "" });
  useEffect(() => {
    if (showButton === "queries") {
      setInitialTypeValue((prev) => {
        prev = query_type.NORMAL;
        return prev;
      })
    }
    else if (showButton === "review") {
      setInitialTypeValue((prev) => {
        prev = query_type.REVIEW_POINTS;
        return prev;
      })
    }
  }, [showButton])

  const handleMigration = async () => {
    try {
      const res = await _fetch(`${process.env.REACT_APP_API_URL}/query/${isQueryModalOpen._id}/migrate`, {
        method: "POST",
        body: {
          targetFinancialYear: selectedTargetFY
        }
      });
      const data = await res.json();

      if (data.success) {
        message.success(data.message);
        allQueriesNormal.refetch();
        allQueriesPrimary.refetch();
        refetch();
        setIsQueryModalOpen(null);
        setSelectedTargetFY(null);
      } else {
        message.error(data.response);
      }
    } catch (error) {
      console.error("Migration error:", error);
      message.error("Failed to migrate query");
    }
  };
  useEffect(() => {
    const tabFromParams = searchParams.get("tab");

    if (tabFromParams) {
      setSelectedTab(tabFromParams);
      setActiveTab(tabFromParams);
      setShowButton(tabFromParams);
    } else {
      if (role === user_role.PRIMARY_CLIENT) {
        setSelectedTab("primary_client_queries");
        setActiveTab("primary_client_queries");
        setShowButton("queries");
      } else {
        setSelectedTab("queries");
        setActiveTab("queries");
        setShowButton("queries");
      }
    }
  }, [searchParams, role, selectedPrimaryClient]);

  const handleOk = () => {
    const htmlCode = mailRef?.current.innerHTML;
    if (!htmlCode) {
      message.error("No queries found");
      return;
    }
    const blobInput = new Blob([htmlCode], { type: "text/html" });
    navigator.clipboard.write([new ClipboardItem({ "text/html": blobInput })]);
    message.success("Email Body copied to clipboard");
  };

  const handleCancel = () => {
    setIsMailModalOpen(false);
  };

  const copySubject = (text) => {
    navigator.clipboard.writeText(text);
    message.success("Email Subject copied to clipboard");
  };

  const callbackTabClicked = (key) => {
    switch (key) {
      case "queries":
        setSelectedTab("queries");
        setSearchParams({ tab: "queries" });
        break;
      case "review":
        setSelectedTab("review");
        setSearchParams({ tab: "review" });
        break;
      case "documents":
        setSelectedTab("documents");
        setSearchParams({ tab: "documents" });
        break;
      case "email":
        setSelectedTab("email");
        setSearchParams({ tab: "email" });
        break;
      case "primary_client_queries":
        setSelectedTab("primary_client_queries");
        setSearchParams({ tab: "primary_client_queries" });
        break;
      default:
        if (role === user_role.PRIMARY_CLIENT || selectedPrimaryClient?._id) {
          setSelectedTab("primary_client_queries");
          setSearchParams({ tab: "primary_client_queries" });
        } else {
          setSelectedTab("queries");
          setSearchParams({ tab: "queries" });
        }
        break;
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="tabled">
          <Modal
            style={{
              top: 0,
            }}
            width="70vw"
            destroyOnClose
            open={modalQueryId}
            centered
            footer={null}
            onOk={() => setModalQueryId(null)}
            onCancel={() => setModalQueryId(null)}
          >
            <Query
              query={modalQueryId}
              change={setUpdatedquery}
              setModalQueryId={setModalQueryId}
              onSuccess={refresh}
            />
          </Modal>
          <Modal
            style={{
              top: 0,
            }}
            width="70vw"
            destroyOnClose
            open={copyQueryModal}
            centered
            footer={null}
            onOk={() => setCopyQueryModal(null)}
            onCancel={() => setCopyQueryModal(null)}
          >
            <CopyQuery
              query={modalQueryId}
              change={setUpdatedquery}
              setCopyQueryModal={setCopyQueryModal}
              onSuccess={refresh}
              query_id_value={queryIdValue}
              // userIds={selectedClients[queryIdValue]}
              setCopyQueryApiFetch={setCopyQueryApiFetch}
            />
          </Modal>
          <Modal
            title="Bulk Assign Queries"
            open={bulkAssignModal}
            footer={null}
            destroyOnClose
            onCancel={() => setBulkAssignModal(false)}
          >
            <BulkAssignClients
              queryIds={selectedRowKeys}
              onSuccess={() => {
                setBulkAssignModal(false);
                setSelectedRowKeys([]);
                allQueriesNormal.refetch();
                allQueriesPrimary.refetch();
              }}
            />
          </Modal>
          <Modal
            open={isMailModalOpen}
            style={{ top: 15, minWidth: 800, body: { height: 480, width: "100%", overflowY: "scroll" } }}
            onCancel={handleCancel}
            footer={[<></>]}
          >
            <Card
              style={{ marginBottom: 10 }}
              headStyle={{ fontSize: "1rem" }}
              title=
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography.Title style={{ fontSize: "1.2rem" }}>
                  Email Subject
                </Typography.Title>
                <Button
                  type="primary"
                  key="back"
                  onClick={() =>
                    copySubject(
                      `Entity Name - ${client?.title} and FY ${moment(
                        selectedFy?.start
                      ).format("YYYY")} - ${moment(selectedFy?.end).format("YY")}`
                    )
                  }
                >
                  Copy Subject
                </Button>
              </div>
            >
              <Typography.Title level={5} >{`Entitiy Name - ${client.title} and FY ${moment(
                selectedFy?.start
              ).format("YYYY")} - ${moment(selectedFy?.end).format("YY")}`}</Typography.Title>
            </Card>
            <Card
              title={<div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography.Title style={{ fontSize: "1.2rem" }}>
                  Email Body
                </Typography.Title>
                <Button type="primary" key="back" onClick={handleOk}>
                  Copy Body
                </Button>
              </div>}
            >
              <div className="d-flex flex-column align-items-start my-4">
                <Typography.Title style={{ fontSize: "1.2rem" }}>
                  Email Body
                </Typography.Title>
                <Button type="primary" key="back" onClick={handleOk}>
                  Copy Body
                </Button>
              </div>
              <div className="d-flex flex-column align-items-start my-4">
                <div
                  ref={mailRef}
                  dangerouslySetInnerHTML={{
                    __html: displayDesc.current,
                  }}
                  style={{ whiteSpace: "pre-line" }}
                />
              </div>
            </Card>
          </Modal>
          <Card variant="borderless" className="circle_box table_space mb-24 w-100">
            <Tabs
              type="card"
              onTabClick={callbackTabClicked}
              defaultActiveKey={activeTab}
              tabBarExtraContent={
                <div
                  style={{
                    display: "flex",
                    padding: "5px",
                    alignItems: "center",
                  }}
                >
                  <Button
                    type="primary"
                    onClick={handleClick}
                    disabled={allQueries?.length === 0 || showButton !== 'queries' || isReadOnly}
                  >
                    Draft Email
                  </Button>
                  <Button
                    type="primary"
                    onClick={handlePrintQueries}
                    disabled={allQueries?.length === 0 || showButton !== 'queries' || isReadOnly}
                    style={{ marginLeft: '10px' }}
                    loading={printLoading}
                  >
                    Print Queries
                  </Button>
                  {role === user_role.STAFF && showButton === 'queries' && (
                    <Button
                      type="primary"
                      style={{ marginLeft: '10px' }}
                      disabled={selectedRowKeys.length === 0}
                      onClick={() => setBulkAssignModal(true)}
                    >
                      Bulk Assign {selectedRowKeys.length > 0 ? `(${selectedRowKeys.length})` : ''}
                    </Button>
                  )}
                  {user.role === user_role.ADMIN && query.get("fy") && (
                    <Button
                      type="link"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        setPermissionModalOpen(query.get("fy"));
                      }}
                    >
                      <DeleteOutlined
                        style={{
                          color: "red",
                          fontSize: "20px",
                        }}
                      />
                    </Button>
                  )}
                  {query.get("fy") && (
                    <Fyassign
                      query={selectedFy}
                      className="p-2"
                      handleFyUpdate={handleFyUpdate}
                      role={""}
                    />
                  )}{" "}
                  {showButton === "queries" && user_role.COMPANY !== role && (
                    <Tooltip
                      title={
                        selectedFy?.status === "CLOSED"
                          ? "Please reopen the FY to add a query"
                          : null
                      }
                    >
                      <Button
                        type="link"
                        onClick={() => {
                          if (isReadOnly) return
                          setShowQuery(true)
                        }
                        }
                        disabled={selectedFy?.status === "CLOSED" || isReadOnly}
                        style={{ color: colorPrimary }}

                      >
                        <BsPlus size={20} /> Add Query
                      </Button>
                    </Tooltip>
                  )}
                  {showButton === "review" && (
                    <Tooltip
                      title={
                        selectedFy.status === "CLOSED"
                          ? "Please reopen the FY to add a review points"
                          : null
                      }
                    >
                      <Button
                        type="link"
                        onClick={() => setShowReviewQuery(true)}
                        disabled={selectedFy.status === "CLOSED"}
                        style={{ color: colorPrimary }}
                      >
                        <BsPlus size={20} /> Add Review Points
                      </Button>
                    </Tooltip>
                  )}
                </div>
              }
            >
              {role !== user_role.PRIMARY_CLIENT && (<items
                key="queries"
                tab={
                  <Typography.Title
                    level={5}
                    className="align-self-start"
                    onClick={() => setShowButton((prev) => {
                      prev = "queries"
                      setIsPrimaryQuery(false);
                      return prev
                    })}
                  >
                    <div className="flex-fill search d-flex">
                      {query.get("entity") ? (
                        <span className="me-3">Queries</span>
                      ) : (
                        "All Queries"
                      )}
                    </div>
                  </Typography.Title>
                }
              >
                <div className="table-responsive">
                  <div
                    className="d-flex flex-fill justify-justify-center"
                    id="fySearch"
                    style={{ padding: "0px 50px" }}
                  >
                    <SearchBox
                      all={allQueries}
                      setshow={setShow}
                      name={placeholder}
                    />
                  </div>
                  <Table
                    rowKey={(record) => record._id}
                    onRow={(record, rowIndex) => {
                      return {
                        onClick: (event) => {
                          // Don't open modal if clicking the checkbox cell
                          if (event.target.type === 'checkbox' || event.target.closest('.ant-checkbox-wrapper')) {
                            return;
                          }
                          setModalQueryId(record?.query_id);
                        },
                      };
                    }}

                    pagination={{
                      current: pagination?.current,
                      pageSize: pagination?.pageSize,
                      total: pagination?.total,
                      showSizeChanger: false,
                      onChange: handleTableChange
                    }}
                    sortDirections={["ascend", "descend", "ascend"]}
                    columns={columns}
                    dataSource={show}
                    className="ant-border-space"
                    rowSelection={
                      role === user_role.STAFF
                        ? {
                          selectedRowKeys,
                          onChange: (keys) => setSelectedRowKeys(keys),
                          getCheckboxProps: (record) => ({
                            disabled: !!record.primary_client_query,
                          }),
                        }
                        : undefined
                    }
                  />
                </div>
              </items>)}
              {(role === user_role.PRIMARY_CLIENT) && (
                <items
                  key="primary_client_queries"
                  tab={
                    <Typography.Title
                      level={5}
                      className="align-self-start"
                      onClick={() => setShowButton((prev) => {
                        prev = "queries"
                        setIsPrimaryQuery(true);
                        return prev
                      })}
                    >
                      <div className="flex-fill search d-flex">
                        {role === user_role.PRIMARY_CLIENT ?
                          "Queries"
                          : "Primary Client"}
                      </div>
                    </Typography.Title>
                  }
                >
                  <div className="table-responsive">
                    <div
                      className="d-flex flex-fill justify-justify-center"
                      id="fySearch"
                      style={{ padding: "0px 50px" }}
                    >
                      <SearchBox
                        all={allQueries}
                        setshow={setShow}
                        name={placeholder}
                      />
                    </div>
                    <Table
                      rowKey={(record) => record._id}
                      onRow={(record, rowIndex) => {
                        return {
                          onClick: (event) => {
                            // Don't open modal if clicking the checkbox cell
                            if (event.target.type === 'checkbox' || event.target.closest('.ant-checkbox-wrapper')) {
                              return;
                            }
                            setModalQueryId(record?.query_id);
                          },
                        };
                      }}

                      pagination={{
                        current: pagination?.current,
                        pageSize: pagination?.pageSize,
                        total: pagination?.total,
                        showSizeChanger: false,
                        onChange: handleTableChange
                      }}
                      sortDirections={["ascend", "descend", "ascend"]}
                      columns={columns}
                      dataSource={show}
                      className="ant-border-space"
                      rowSelection={
                        role === user_role.STAFF
                          ? {
                            selectedRowKeys,
                            onChange: (keys) => setSelectedRowKeys(keys),
                            getCheckboxProps: (record) => ({
                              disabled: !!record.primary_client_query,
                            }),
                          }
                          : undefined
                      }
                    />
                  </div>
                </items>
              )}
              {selectedFy && role !== user_role.PRIMARY_CLIENT && (
                <>
                  <items
                    tab={
                      <Typography.Title
                        level={5}
                        className="align-self-start"
                        onClick={() => {
                          setShowButton("review");
                        }}
                      >
                        Review Points
                      </Typography.Title>
                    }
                    key="review"
                  >
                    <ReviewPoints
                      fy_id={selectedFy?._id}
                      toggle={reviewQueryRefreshToggle}
                      setQueryMigrateModal={setIsQueryModalOpen}
                    />
                  </items>
                  <items
                    tab={
                      <Typography.Title
                        level={5}
                        className="align-self-start"
                        onClick={() => setShowButton("doc")}
                      >
                        Documents
                      </Typography.Title>
                    }
                    key="documents"
                  >
                    <Documents
                      fy_id={fy?._id}
                      toggle={toggle}
                      company_id={company?._id}
                      setToggle={setToggle}
                    />
                  </items>
                </>
              )}
              {selectedFy && (
                <>
                  <items
                    tab={
                      <Typography.Title
                        level={5}
                        className="align-self-start"
                        style={{
                          background: "linear-gradient(#4CB8C4, #3CD3AD)",
                          "-webkit-background-clip": "text",
                          "-webkit-text-fill-color": "transparent",
                          textShadow: "0 0 5px #4CB8C460",
                        }}
                      >
                        Send Email
                      </Typography.Title>
                    }
                    key="email"
                  >
                    <div style={{ padding: "0px 20px" }}>
                      <SendEmailView
                        comments={comments}
                        fy={selectedFy?._id}
                        setComments={setComments}
                        selectedPrimaryClient={selectedPrimaryClient}
                      />
                    </div>
                  </items>
                </>
              )}
            </Tabs>
          </Card>
        </div >
      )
      }
      <SendDocumentsModal
        open={showDocs}
        setOpen={setShowDocs}
        setToggle={setToggle}
      />
      <PermissionModal
        visible={permissionModalOpen !== null}
        setVisible={setPermissionModalOpen}
        onSuccess={deleteFY}
        child={
          <p>
            Are you sure you want to delete this <b>Financial Year</b>? This
            will delete all the <b>Queries</b>, and <b>Attachments</b> related
            to this Financial Year.
          </p>
        }
      />
      <Modal
        title={`Migrate Query ${isQueryModalOpen?.title}`}
        open={isQueryModalOpen}
        onCancel={() => {
          setIsQueryModalOpen(null)
          setSelectedTargetFY(null)
        }}
        onOk={handleMigration}
        okText="Save"
      >
        <div style={{ marginBottom: "16px" }}>
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label>Current Entitiy</label>
          <Select
            style={{ width: "100%" }}
            value={client?._id}
            disabled
          >
            <Option value={client?._id}>
              {client?.title}
            </Option>
          </Select>
        </div>

        <div className="mb-3">
          <label>Target Entitiy </label>
          <span>Title | FY | Job Type | Period</span>
          <Select
            style={{ width: "100%" }}
            showSearch
            placeholder="Select target company"
            onChange={value => setSelectedTargetFY(value)}
            value={selectedTargetFY?._id}
            filterOption={(input, option) => {
              const com = allFIlteredFys.find(item => item._id === option?.value);
              if (!com) return false;
              return (com.client?.title || "")
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
          >
            {allFIlteredFys?.map(com => (
              <Option key={com._id} value={com._id}>
                {com.client?.title} | {moment(com.start).format("YYYY")} - {moment(com.end).format("YY")} |{" "}
                {com.fy_type || "Not Set"} | {com.period_type || "Not Set"}
              </Option>
            ))}
          </Select>

        </div>
      </Modal>
      {showQuery || showReviewQuery ? <CreateQuery show={showQuery || showReviewQuery} setShow={showQuery ? setShowQuery : setShowReviewQuery} initialTypeValue={initialTypeValue}></CreateQuery> : ''}
    </>
  );
}